import { Component, OnInit } from '@angular/core';
import { IdexService } from 'app/idex.service';

@Component({
  selector: 'app-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.css']
})
export class PlanComponent implements OnInit {
  user : any
  unlimitSpace = false;
  spacePercent = 0;

  plans: any[] = [
    {
      label: 'Current Plan',
      title: 'zDox Free Basic',
      features: [
        {des:'Send 3 documents for sign' , status:true},
        {des:'5 GB of Personal Storage' , status:true},
        {des:'Integrate With Google App.' , status:true},
        {des:'Integrate with O365' , status:true},
        {des:'Template' , status:false},
        {des:'Social Collaboration' , status:false},
        {des:'Document workflow' , status:false}
      ]
    },
    {
      label: 'Recommended for you',
      title: 'zDox Starter',
      features: [
        {des:'Unlimited send documents for sign' , status:true},
        {des:'10 GB of Personal Storage' , status:true},
        {des:'Integrate With Google App.', status:true},
        {des:'Integrate with O365' , status:true},
        {des:'Template' , status:true},
        {des:'Social Collaboration' , status:true},
        {des:'Document workflow' , status:true}
      ]
    },
    {
      label: 'Recommended for you',
      title: 'zDox Team Starter',
      features: [
        {des:'All zDox Starter features', status:true},
        {des:'20 GB of Personal Storage', status:true},
        {des:'Team Collaboration 10 User', status:true},
        {des:'Integrate with GetInvoice' , status:true}
      ]
    }
  ];


  constructor(public service: IdexService) { }

  ngOnInit(): void {
    this.user = this.service.user;
 if(this.user.quota <= 0||this.user.quota === undefined){
    this.unlimitSpace = true;
    this.spacePercent = 0;
 } else {
    this.spacePercent = (this.user.used / this.user.quota) * 100;
 }
  }
}
